module.exports = __webpack_public_path__ + "img/img35.4425b4d2.png";